
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcBearingIndicator as ObcBearingIndicatorElement} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/bearing-indicator/bearing-indicator.js';
 
 
 

 
 export const ObcBearingIndicator = createComponent({
   react: React,
   tagName: 'obc-bearing-indicator',
   elementClass: ObcBearingIndicatorElement,
   events: {
     
   }
  });
 
 